import TemplateOverview from './TemplateOverview'

const ROUTES = [
  ...TemplateOverview
]

export default ROUTES
